<script setup lang="ts">
import { computed, StyleValue } from 'vue'

import { Coordinates } from '@collector/shared-ui-domain'

import { mapCoordinateToDouble } from './utils'

interface Props {
  coordinates: Coordinates
  ballSrc: string
}

const props = defineProps<Props>()

// computed
const position = computed<StyleValue>(() => ({
  top: `${mapCoordinateToDouble(props.coordinates.y)}%`,
  left: `${mapCoordinateToDouble(props.coordinates.x)}%`,
}))
</script>

<template>
  <img
    class="pointer-events-none absolute w-[2.5%] min-w-3 -translate-x-1/2 -translate-y-1/2 transform select-none"
    :src="ballSrc"
    :style="position"
  />
</template>
